var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTraining3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 183,
    viewBox: "0 0 201 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 98.4279L1.0361 139.871V42.4794L100.5 1.03613L199.964 42.4794V139.871L100.5 98.4279Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.102 0.0796987C100.357 -0.0265662 100.643 -0.0265662 100.898 0.0796987L200.362 41.523C200.749 41.6839 201 42.0611 201 42.4794V139.871C201 140.218 200.827 140.541 200.539 140.733C200.25 140.925 199.885 140.961 199.565 140.828L100.5 99.5503L1.43458 140.828C1.11481 140.961 0.749604 140.925 0.461367 140.733C0.173131 140.541 0 140.218 0 139.871V42.4794C0 42.0611 0.251496 41.6839 0.637589 41.523L100.102 0.0796987ZM2.07217 43.1701V138.317L100.102 97.4715C100.357 97.3652 100.643 97.3652 100.898 97.4715L198.928 138.317V43.1701L100.5 2.1585L2.07217 43.1701Z",
    fill: "#031D60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0361 42.479L100.5 83.9223V181.314L1.0361 139.871V42.479Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.461367 41.6174C0.749604 41.4252 1.11481 41.3898 1.43458 41.5231L100.898 82.9664C101.285 83.1272 101.536 83.5045 101.536 83.9227V181.314C101.536 181.661 101.363 181.984 101.075 182.177C100.786 182.369 100.421 182.404 100.102 182.271L0.637589 140.828C0.251496 140.667 0 140.289 0 139.871V42.4794C0 42.133 0.173131 41.8095 0.461367 41.6174ZM2.07217 44.0336V139.18L99.4639 179.76V84.6135L2.07217 44.0336Z",
    fill: "#031D60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.964 42.479L100.5 83.9223V181.314L199.964 139.871V42.479Z",
    fill: "#59EAD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.539 41.6174C200.827 41.8095 201 42.133 201 42.4794V139.871C201 140.289 200.749 140.667 200.362 140.828L100.899 182.271C100.579 182.404 100.214 182.369 99.9253 182.177C99.6371 181.984 99.4639 181.661 99.4639 181.314V83.9227C99.4639 83.5045 99.7154 83.1272 100.102 82.9664L199.565 41.5231C199.885 41.3898 200.25 41.4252 200.539 41.6174ZM101.536 84.6135V179.76L198.928 139.18V44.0336L101.536 84.6135Z",
    fill: "#031D60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5412 65.2729L85.9948 94.2833V158.52L15.5412 129.51V65.2729Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9647 64.4125C15.2519 64.2202 15.6161 64.1837 15.9357 64.3153L86.3894 93.3257C86.7776 93.4855 87.0309 93.8639 87.0309 94.2837V158.521C87.0309 158.866 86.8586 159.189 86.5714 159.382C86.2842 159.574 85.92 159.61 85.6004 159.479L15.1468 130.469C14.7585 130.309 14.5052 129.93 14.5052 129.511V65.2734C14.5052 64.9277 14.6775 64.6049 14.9647 64.4125ZM16.5773 66.8205V128.817L84.9588 156.974V94.9776L16.5773 66.8205Z",
    fill: "#031D60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9948 105.68L21.7577 132.618L15.5412 129.51V65.2729L85.9948 94.2833V105.68Z",
    fill: "url(#paint0_linear_2598_2848)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9647 64.4125C15.2519 64.2202 15.6161 64.1837 15.9357 64.3153L86.3894 93.3257C86.7776 93.4855 87.0309 93.8639 87.0309 94.2837V105.681C87.0309 106.098 86.7805 106.475 86.3955 106.636L22.1584 133.574C21.88 133.691 21.5644 133.68 21.2944 133.545L15.0779 130.437C14.7269 130.262 14.5052 129.903 14.5052 129.51V65.2734C14.5052 64.9277 14.6775 64.6049 14.9647 64.4125ZM16.5773 66.8205V128.87L21.7957 131.479L84.9588 104.992V94.9776L16.5773 66.8205Z",
    fill: "#031D60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2598_2848",
    x1: 85.9948,
    y1: 84.9585,
    x2: 15.5412,
    y2: 98.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#59EAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59EAD8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTraining3);
export default __webpack_public_path__ + "static/media/model-training-3.4b11dee6f14df3df9e2a7714d732bf10.svg";
export { ForwardRef as ReactComponent };